// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"468":"df241702","580":"5b3634c8","787":"d7af9de9","959":"077fa8b2"}[chunkId] + ".chunk.js";
};